/**
 * Width of the page: the header row and the content share it, so their edges line up. Up to 1535px wide it is Tailwind's
 * max-w-7xl (1280px) as before; from 2xl (1536px) it grows to 1840px with 32px sides, so a 1920px screen is used
 * instead of leaving a third of it empty (#2242 rev 3). Long-text pages (Learn, Privacy) keep their own narrow column.
 */
export const PAGE_WIDTH = 'mx-auto w-full max-w-7xl px-4 sm:px-6 2xl:max-w-[115rem] 2xl:px-8';
